/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=["dash","dash-dot","dot","long-dash","long-dash-dot","long-dash-dot-dot","none","short-dash","short-dash-dot","short-dash-dot-dot","short-dot","solid"];export{o as lineStyles};
